export default "__VITE_ASSET__DiMURFF2__"